export const allergensList = [
  'Peanuts',
  'Nuts - All Nuts',
  'Nuts - Almonds',
  'Nuts - Cashews',
  'Nuts - Hazelnut',
  'Nuts - Pecans',
  'Nuts - Pistachio',
  'Nuts - Walnuts',
  'Sesame',
  'Cereals Contain Gluten (All)',
  'Gluten - Barley',
  'Gluten - Oats',
  'Gluten - Rye',
  'Gluten - Spelt (Wheat)',
  'Gluten - Wheat',
  'Crustacean',
  'Celery & Celeriac',
  'Egg',
  'Fish',
  'Milk',
  'Mustard',
  'Soya',
  'Sulphites',
  'Pine Nuts'
]

export const adjustmentNameAllergens = {
  'Nuts - All Nuts': 'Nuts',
  'Nuts - Almonds': 'Nut - Almonds',
  'Nuts - Cashews': 'Nut - Cashews',
  'Nuts - Hazelnut': 'Nut - Hazelnut',
  'Nuts - Pecans': 'Nut - Pecans',
  'Nuts - Pistachio': 'Nut - Pistachio',
  'Nuts - Walnuts': 'Nut - Walnuts',
  'Cereals Contain Gluten (All)': 'Cereals Containing Gluten'
}

export const adjustmentNameSuitables = {
  Vegetarian: 'Vegetarians',
  Vegan: 'Vegans'
}

export const allNut =
  'Nuts - All Nuts,Nuts - Almonds,Nuts - Cashews,Nuts - Hazelnut,Nuts - Pecans,Nuts - Pistachio,Nuts - Walnuts'
export const allGluten =
  'Cereals Contain Gluten (All),Gluten - Barley,Gluten - Oats,Gluten - Rye,Gluten - Spelt (Wheat),Gluten - Wheat'
export const allList = {
  all: 'All',
  nut: 'Nuts',
  gluten: 'Gluten',
  nutLabel: 'Nuts - All Nuts',
  glutenLabel: 'Cereals Contain Gluten (All)'
}

export const suitablesList = ['Vegetarian', 'Vegan']
